__turbopack_context__.v({
  "card": "MWGhxG_card",
  "thumbnailWrapper": "MWGhxG_thumbnailWrapper",
});
